import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout/Layout';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Profile from './components/Profile';
import DailyReport from './components/Reports/DailyReport';
import CheckReport from './components/Reports/CheckReport';
import FestiveReport from './components/Reports/FestiveReport';
import OfferReport from './components/Reports/OfferReport';
import DataTable from './components/DataTable';
import DailyReporting from './components/DailyRepoting';
import ChequeReporting from './components/ChequeReporting';
import DiwaliReporting from './components/DiwaliReporting';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Login Route (No Layout) */}
            <Route path="/login" element={<Login />} />

            {/* Protected Routes with Layout */}
            <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
            <Route path="/profile" element={<Layout><Profile /></Layout>} />
            <Route path="/daily-reporting" element={<Layout><DailyReporting /></Layout>} />
            <Route path="/cheque-reporting" element={<Layout><ChequeReporting /></Layout>} />
            <Route path="/diwali-reporting" element={<Layout><DiwaliReporting /></Layout>} />
            <Route path="/reports/daily" element={<Layout><DailyReport /></Layout>} />
            <Route path="/reports/check" element={<Layout><CheckReport /></Layout>} />
            <Route path="/reports/festive" element={<Layout><FestiveReport /></Layout>} />
            <Route path="/reports/offer" element={<Layout><OfferReport /></Layout>} />
            <Route path="/data-table" element={<Layout><DataTable /></Layout>} />

            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>

          {/* Toast Notifications Container */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
